import { SAVE_TURN_ID } from '@/store/copyTurn/index'

const saveSelectedTurnId = (turnId) => (dispatch) => {
  dispatch(SAVE_TURN_ID(turnId))
}

export { saveSelectedTurnId }
